import React from 'react'

import { getOrderImageUrl } from '@components/utils/getOrderImageUrl'
import { AspectBox } from '@fourthwall/components'

import { OrderPopover } from '../OrderPopover'
import { PhotoThumbnail } from '../PhotoThumbnail'
import { QuantityBadge } from '../QuantityBadge'
import { Tooltip } from '../Tooltip'
import * as S from './styled'
import type { TableProductsListProps } from './types'

export const TableProductsList = ({
  image,
  offers,
  offersCancelled,
  donation,
  quantity,
}: TableProductsListProps) => {
  const getImageUrl = () => {
    if (image) return image

    return getOrderImageUrl(offers, offersCancelled)
  }

  const renderContent = (hasTooltip: boolean) => (
    <S.ImageContainer $hasTooltip={hasTooltip}>
      <AspectBox ratio="3:4">
        <PhotoThumbnail url={getImageUrl()} size="large" />
        {quantity > 1 ? <QuantityBadge quantity={quantity} /> : null}
      </AspectBox>
    </S.ImageContainer>
  )

  if (!offers.length) {
    return renderContent(false)
  }

  return (
    <Tooltip
      content={<OrderPopover products={offers} donation={donation?.value} $padding="small" />}
      placement="bottom-start"
      size="xlarge"
    >
      {renderContent(true)}
    </Tooltip>
  )
}
